<template>
	<div class="sf-search-layout__body__container">
		<sf-search-layout>
			<el-row :gutter="20">
				<el-col :span="3">
					<search-input
						:label="getMessage_('QWCC000904')"
						paramKey="partsNo"
					/><!--다국어 등록시 메세지 ID MWCC 시스템은 센터 메세지 타입은 라벨로 선택하고 등록함-->
				</el-col>
				<el-col :span="3">
					<useYn-select @reload="searchList()" />
				</el-col>
			</el-row>
			<template slot="button">
				<sf-button line icon="search" :onClick="() => searchList()" v-if="isButton_(scrId, 'CR')">
					{{ getButtonMsg_(scrId, 'CR') }}
				</sf-button>
			</template>
		</sf-search-layout>
	</div>
</template>

<script>
import { rootComputed } from '@/store/common/helpers';
import { serviceComputed, serviceMethods } from '@/views/qms/PartsInfo/store/helpers';
import SearchInput from './SearchInput.vue';
import UseYnSelect from './UseYnSelect.vue';
//import { getVariableValue } from '@/views/gqmsCommUtil/gqmsComUtil'; //공통함수 import
export default {
	props: {
		scrId: { type: String, default: '' }
	},
	components: { SearchInput, UseYnSelect },
	computed: {
		...rootComputed,
		...serviceComputed
	},
	methods: {
		...serviceMethods,
		searchList(currentPage = 1, pageUnit = 30) {
			this.$sf_toggleLoading(true);
			this.getPartsInfo_({ currentPage, pageUnit })
				.catch(error => {
					this.$sf_toast({
						type: 'error',
						message: error.message
					});
					Promise.reject(error);
				})
				.finally(() => {
					this.$sf_toggleLoading(false);
				});
		}
	},
	async created() {
		try {
			await this.getCommCodes_({ key: 'useYnList', codeType: 'USE_YN' });

			let list = [];

			this.useYnList.forEach(row => {
				list.push({
					label: row.commCdName,
					value: row.commCd
				});
			});

			this.setState_({ key: 'gridUseYnList', value: list });

			//let varList = await getVariableValue('sdfa', 'Y');

			//console.log('varList >>>>>>>>>>>', varList.varValue);

			await this.searchList();
		} catch (error) {
			this.$sf_toast({
				type: 'error',
				message: error.message
			});
			return error;
		}
	}
};
</script>

<style></style>
